import React, { Component } from "react";
import PropTypes from "prop-types";
import { debounce } from "lodash";
import { observer } from "mobx-react";
import { Modal, Search, Button, Message } from "semantic-ui-react";
import PromiseButton from "../components/element/PromiseButton";
import CustomerMerge, { getCustomerTitle } from "../stores/CustomerMerge";
import ContentLoader from "~/components/element/ContentLoader";

const CreditsCardWarning = ({ customerTitle }) => (
  <Message color="orange">
    Warning. Both customer have credit cards associated to their account. Credits cards from {customerTitle} will&nbsp;
    be <strong>lost</strong> after merging.
  </Message>
);

CreditsCardWarning.propTypes = {
  customerTitle: PropTypes.string.isRequired,
};

@observer
class CustomerMergeWidget extends Component {
  getContent() {
    const { store } = this.props;
    const { customerTo, loading } = store;

    // An API call is in process.
    if (loading) {
      return <ContentLoader />;
    }

    // customerFrom data has been fetched, but the user needs to select the customerTo.
    if (!customerTo.customerId) {
      return this.step1();
    }

    // Confirm merging customers.
    return this.step2();
  }

  step1() {
    const { store } = this.props;
    const { customerFrom, searchValue, searching, searchResults } = store;

    return (
      <div className="ui two column very relaxed grid">
        <div className="column" style={{ position: "relative" }}>
          <strong>Current Customer</strong>
          <br />
          {getCustomerTitle(customerFrom)}
          <br />
          {customerFrom.email}
        </div>
        <div className="column" style={{ position: "relative" }}>
          <strong style={{ padding: 10 }}>Customer to merge into</strong>
          <br />
          <Search
            loading={searching}
            onResultSelect={(e, { result }) => store.handleSearchSelect(result.title)}
            onSearchChange={debounce((event, data) => store.handleSearchChange(data.value), 500, { leading: true })}
            results={searchResults.map(customer => ({ title: getCustomerTitle(customer) }))}
            value={searchValue}
          />
        </div>
      </div>
    );
  }

  step2() {
    const { store } = this.props;
    const { customerFrom, customerTo } = store;

    return (
      <div className="ui grid">
        <div className="sixteen wide column">
          <strong>
            You are about to merge {customerFrom.fullName} into {customerTo.fullName}
          </strong>
          <br />
          {customerFrom.fullName}&apos; Tours ({customerFrom.toursCount}) will be moved over the new customer.
          <br />
          This process is <strong>not</strong> reversible.
          {customerFrom.creditsCardCount > 0 && customerTo.creditsCardCount > 0 ? (
            <div>
              <br />
              <br />
              <CreditsCardWarning customerTitle={getCustomerTitle(customerTo)} />
            </div>
          ) : null}
        </div>
        <div className="eight wide column">
          <strong>Original Customer</strong>
          <br />
          {getCustomerTitle(customerFrom)}
          <br />
          {customerFrom.email}
        </div>
        <div className="eight wide column">
          <strong>Customer to merge into</strong>
          <br />
          {getCustomerTitle(customerTo)}
          <br />
          {customerTo.email}
        </div>
        <div className="sixteen wide column">
          <div style={{ float: "right" }}>
            <Button basic color="grey" onClick={() => store.goToStep1()}>
              back
            </Button>
            <PromiseButton basic color="teal" onClick={() => store.merge()}>
              Merge
            </PromiseButton>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { store } = this.props;

    return (
      <Modal
        open={store.modalOpen}
        style={{ maxWidth: 800, minHeight: "70vh" }}
        closeIcon="close"
        onClose={() => store.closeModal()}
      >
        <Modal.Header>
          <strong>Merge Customer</strong>
        </Modal.Header>
        <Modal.Content>{this.getContent()}</Modal.Content>
      </Modal>
    );
  }
}

CustomerMergeWidget.propTypes = {
  store: PropTypes.instanceOf(CustomerMerge),
};

export default CustomerMergeWidget;
